module.exports = __webpack_public_path__ + "img/threedots.cb12f7d6.svg";